<template>
  <header class="base-header">
    <div class="menu-container">
      <img
        v-if="isCustomizeCheckout"
        src="@/assets/images/zeus/zeus_full.svg"
        width="110"
        class="mr-4"
      />
      <div v-else>
        <snow-button
          icon="ph ph-sidebar fs-20"
          size="sm"
          id="button-menu-desktop"
          variant="borderless"
          @click="$emit('toggle-menu')"
        />
        <snow-button
          icon="ph ph-list fs-20 text-orange"
          size="sm"
          id="button-menu-mobile"
          variant="borderless"
          @click="$emit('toggle-menu')"
        />
      </div>
      <img src="@/assets/images/zeus/zeus_full_invert.svg" class="logo" />
      <breadcrumbs id="breadcrumbs" />
    </div>

    <template v-if="$permissions.currentCompany">
      <div class="d-none d-lg-block">
        <span class="text-dark-40">
          Central
        </span>
        <strong>{{ $permissions.currentCompany.company.name }}</strong>
      </div>
      <div class="button-container">
        <snow-button
          @click="leaveCompany"
          size="sm"
          text="Sair"
          variant="outline"
        />
      </div>
    </template>

    <company-dropdown v-else-if="companies.length" :companies="companies" />
  </header>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import CompanyDropdown from "@/components/user/CompanyDropdown";

import { setToken } from "@/setup/api";
import { get } from "lodash";
export default {
  components: {
    CompanyDropdown,
    Breadcrumbs
  },
  data() {
    return {
      logoutDialog: false
    };
  },
  computed: {
    companies() {
      const base = get(this.$user, "user.company_base");
      return get(this.$user, "user.companies", []).filter(
        c => c.company.id !== base
      );
    },
    isCustomizeCheckout() {
      return this.$route.name == "product-customize-checkout";
    }
  },
  methods: {
    leaveCompany() {
      setToken(this.$user.user.token);
      setTimeout(() => {
        window.location.href = "/";
      }, 1);
    }
  }
};
</script>

<style lang="scss">
.base-header {
  background-color: var(--bg-1);
  z-index: 11;

  padding: 20px 28px;
  height: var(--header-height);
  position: fixed;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--dark-10);
  box-sizing: border-box;

  .menu-container {
    display: flex;
    align-items: center;
    gap: 16px;

    @media screen and (max-width: 991px) {
      gap: 12px;
    }
  }

  .ph-sidebar {
    cursor: pointer;
  }

  .button-container {
    width: 50px;
  }

  .logo {
    max-height: 28px;
    display: none;
  }

  #button-menu-mobile {
    display: none;
  }

  @media screen and (max-width: 991px) {
    background: #013578;
    .logo {
      display: block;
    }
    .ph-list {
      color: var(--light);
    }
    #button-menu-desktop {
      display: none;
    }
    #button-menu-mobile {
      display: block;
    }
    #breadcrumbs {
      display: none;
    }
  }
}
</style>
